import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';

import { Observable, BehaviorSubject } from 'rxjs';

interface TableRow {
    _id: string;
}

class TableDataSource implements DataSource<TableRow> {
    private _dataSubject = new BehaviorSubject<TableRow[]>([]);

    constructor() {
    }

    connect(collectionViewer: CollectionViewer): Observable<TableRow[]> {
        return this._dataSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this._dataSubject.complete();
    }

    next(data) {
        this._dataSubject.next(data);
    }
}

@Component({
  selector: 'app-market-table-price-history',
  templateUrl: './table-price-history.component.pug',
  styleUrls: ['./table-price-history.component.less']
})
export class TablePriceHistoryComponent implements OnInit, OnChanges {
    @Input() data: TableRow[] = [];

    private _columnsSbj = new BehaviorSubject<string[]>([
        'date', 'transactions', 'volume', 'price'
    ]);

    public dataSource: TableDataSource;
    public columns$ = this._columnsSbj.asObservable();

    constructor() {
        this.dataSource = new TableDataSource;
    }

    ngOnInit() {
    }

    ngOnChanges(changes) {
        if ('data' in changes) {
            this.dataSource.next(changes.data.currentValue);
        }
    }

}
